import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import { Row, Col } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import OverrideButton from './override_button';

export default function MultiSelectOption({ defaults, option, onUpdate, onRemove }) {
  const values = {};
  const overrideDefaultParams = {};
  option.options.forEach((childOption) => {
    overrideDefaultParams[childOption.name] = false;
    if (defaults.hasOwnProperty(childOption.name)) {
      values[childOption.name] = defaults[childOption.name];
    }
  });
  const disabled = isEmpty(values);


  return (
    <Row className="row-eq-height">
      <Col md={6} xs={8}>
        <div className="form-group grow mb-0">
          <Row className="d-flex m-0">
            <Col className="p-0" xs={3}>
              <div  className="control-label w-100 h-100">
                <label>{option.label}</label>
              </div>
            </Col>
            <Col className={`border ${disabled ? 'd-flex align-items-center' : ''}`} xs={9}>
              {disabled && (
                <span className="text-muted">Buildout Default</span>
              )}
              {!disabled &&
                option.options.map(childOption => (
                  <ManagedInput
                    id={`input-${childOption.name}`}
                    key={childOption.name}
                    label={childOption.label}
                    name={childOption.name}
                    type="checkbox"
                    value={!!defaults[childOption.name]}
                    onChange={onUpdate}
                  >
                    {childOption.label}
                  </ManagedInput>
                ))
              }
            </Col>
          </Row>
        </div>
      </Col>
      <Col md={6} xs={4}>
        <OverrideButton
          disabled={disabled}
          onRemove={() => onRemove(option.options.map(child => child.name))}
          onReset={() => onUpdate(overrideDefaultParams)}
        />
      </Col>
    </Row>
  );
}

MultiSelectOption.propTypes = {
  defaults: PropTypes.object,
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }),
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
